import { render } from "./ResumePanel.vue?vue&type=template&id=513af352&scoped=true"
import script from "./ResumePanel.vue?vue&type=script&lang=js"
export * from "./ResumePanel.vue?vue&type=script&lang=js"

import "./ResumePanel.vue?vue&type=style&index=0&id=513af352&lang=scss&scoped=true"

import exportComponent from "/Volumes/TRENTDEVELOPMENT/www/classmarker_pre_release_production/web_apps/test-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513af352"]])

export default __exports__